import { PlayHubApi } from 'apps/BWW_PLAY_HUB/modules/utils/Api';
import { IconChevron } from 'components/Icons/IconChevron';
import { map } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { HOCisTrue } from 'components/HOCisTrue';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 30px 20px;
  -webkit-box-flex: 1;
  flex: 1;
`;

export const ContentTitle = styled.div`
  font-size: 16px;
  font-family: ${({theme}) => theme.fonts.bold};
  margin-top: 20px;
  line-height: 23px;
  letter-spacing: -0.5px;
  text-align: center;
`;

export const ContentText = styled.div`
  margin-top: 10px;
  font-family: ${({theme}) => theme.fonts.normal};
  font-size: 14px;
  line-height: 22px;
  color: #FFF;
  word-wrap: break-word;
`;

const WrapperStyled = styled(Wrapper)`
  background: #000;
  min-height: 100%;

  strong {
	font-family: ${({theme}) => theme.fonts.bold};
  }

  u {
	text-decoration: underline;
  }

  td {
	border: 1px solid #fff;
	padding: 4px;
  }

  li {
	list-style: disc;
  }
`;
const LargeHeader = styled.div`
  color: #FFD200;
  font-size: 38px;
  line-height: 38px;
  text-transform: uppercase;

  &:not(:first-of-type) {
	margin-top: 50px;
  }
`;

const SmallHeader = styled.div`
  color: #FFF;
  font-size: 20px;
  font-family: 'Eund-Bold', sans-serif;
  margin-top: 20px;
  line-height: 28px;
  letter-spacing: -0.5px;
  text-transform: uppercase;
  margin-bottom: 10px;
`;

const ContentTextStyled = styled(ContentText)`
  p {
	margin: 5px 0;
  }

  ul {
	margin: 5px;
  }
`;

const Accordion = styled.button`
  background: none;
  outline: none;
  width: 100%;
  height: 60px;
  color: #fff;
  text-align: left;
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: 38px;
  border: none;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  cursor: pointer;
`;

const HelpContent = styled.p`

`;

/**
 * max-func-body-length, no-big-function are disabled because form items can't be easily split into small chunks,
 * and this will make code more harder to support
 *
 * react-a11y-anchors - disabled because this is clients wish to use such hrefs
 */
// tslint:disable-next-line:max-func-body-length no-big-function react-a11y-anchors
export const RulesPage = () => {
	window.scroll({
		top: 0,
		left: 0,
		behavior: 'smooth'
	});

	const [terms, setTemrs] = useState([{
		title: '',
		text: ''
	}])

	const fetchTriviaTerms = useCallback(async () => {
		const response = await PlayHubApi.JSON.terms_trivia();
		if (response) {
			setTemrs(response)
		}
	}, []);

	// const fetchPPTerms = useCallback(async () => {
	// 	const response  = await ECOApi.JSON.terms_pp();
	// 	console.log(response);
	// }, []);

	useEffect(() => {
		fetchTriviaTerms()
	}, [fetchTriviaTerms])

	const [picksVisibility, setPicks] = React.useState(false);
	const togglePicks = () => setPicks(!picksVisibility);
	const picksChevron = picksVisibility ? 'top' : 'bottom';

	const [triviaVisibility, setTrivia] = React.useState(false);
	const toggleTrivia = () => setTrivia(!triviaVisibility);
	const triviaChevron = triviaVisibility ? 'top' : 'bottom';

	return (
		<WrapperStyled>
			<Accordion onClick={togglePicks}>
				<span>Picks & Props</span>
				<IconChevron color={'#fff'} width={20} height={20} to={picksChevron}/>
			</Accordion>
			<HOCisTrue when={picksVisibility}>
				<div>
					<LargeHeader>OFFICIAL RULES – 2022 Monthly Contests</LargeHeader>
					<ContentTextStyled>
						<SmallHeader>
							<strong>
								PLEASE CAREFULLY READ THESE RULES BEFORE PARTICIPATING IN THE BUFFALO WILD WINGS PICKS
								AND PROPS PROMOTION (“PROMOTION”) AS THESE RULES AFFECT YOUR LEGAL RIGHTS AND
								OBLIGATIONS.
							</strong>
						</SmallHeader>

						<SmallHeader>
							<strong>
								NO PURCHASE NECESSARY TO ENTER THE PROMOTION OR WIN. A PURCHASE WILL NOT INCREASE YOUR
								CHANCES OF WINNING.
							</strong>
							PROMOTION IS STRICTLY FOR ENTERTAINMENT PURPOSES AND IS NOT INTENDED TO BE USED IN ANY WAY
							FOR GAMBLING OR SPORTS WAGERING PURPOSES (OR TO CONDUCT, ADVERTISE OR PROMOTE ANY FORM OF
							GAMBLING). PROMOTION IS SUBJECT TO ALL APPLICABLE FEDERAL, STATE AND LOCAL LAWS. VOID WHERE
							PROHIBITED.
							<strong>MESSAGE & DATA RATES MAY APPLY.</strong>
						</SmallHeader>

						<p>
							<strong>
								<u>IMPORTANT NOTICE: </u>
								THIS PROMOTION IS SUBJECT TO BINDING ARBITRATION AND A WAIVER OF CLASS ACTION RIGHTS AS
								DETAILED BELOW.
							</strong>
						</p>

						<SmallHeader>
							<strong>PROMOTION DESCRIPTION.</strong>
						</SmallHeader>

						<p>
							The Promotion IS FREE TO PLAY. The Promotion takes place via the official Buffalo Wild Wings
							mobile application only
							(the "<u>BWW App</u>") and is administered and scored according to the game rules
							as provided in the BWW App. Promotion is sponsored by Buffalo Wild Wings, Inc.,
							Three Glenlake Parkway NE Atlanta, GA 30328 ("<u>BWW</u>" or "<u>Sponsor</u>").
							Entrants to the Promotion ("<u>Player</u>" or "<u>Players</u>")
							will have the opportunity to play games in the BWW App for the opportunity to
							win BWW rewards points as well as other prizes as provided in these Rules.
						</p>
						<p>
							<strong>PROMOTION PERIOD.</strong>
							Promotion begins at 11:00 AM EST on January 1st, 2022 and ends at 11:59 PM EST on December
							31st, 2022 (“Promotion Period”).{' '}
							Each “Promotion Day” will run starting from 12:01 AM EST on a given day until 11:59 PM EST
							on that day.{' '}
							Each “Promotion Month” will run from 12:01 AM EST on the first day of the month and end on
							11:59 PM EST on the last day of the month.{' '}
							Potential winners will be determined, and prizes awarded throughout the Promotion Period as
							further set forth these Rules.{' '}
						</p>

						<p>
							<strong>ELIGIBILITY TO PARTICIPATE.</strong> P. Players must be 21 years of age or older, a
							resident of one of the 50 United States or DC, and eligible to download and use the BWW App
							to participate in the Promotion. The following individuals are not eligible to participate
							in the Promotion: (a) owners, directors, employees, and representatives of Buffalo Wild
							Wings, Inc., Inspire Brands, Inc., and its parents, affiliates, franchisees, licensees,
							agents and vendors, and their respective advertising, promotion and fulfillment agencies,
							promotional partners, and entities involved with the development, implementation and
							handling of the Promotion (collectively, the “Promotion Entities”) and (b) the immediate
							family (spouse, parents and step-parents, siblings and step-siblings, and children and
							step-children, regardless of where they reside) and household members (people who share the
							same residence at least three (3) months out of the year, whether or not related) of each
							such individual. Potential winners are subject to verification by BWW. A Player is not a
							winner of any prize unless and until eligibility is verified and Player is notified that
							verification is complete.
						</p>
						<p>
							Each Player fully and unconditionally accepts these Official Rules and the decisions of
							Sponsor, which are final and binding in all matters relating to the Promotion and waives any
							right to claim ambiguity in these Official Rules.
						</p>

						<p>
							<strong>MARKETING COMMUNICATIONS.</strong> : By entering the Promotion, each Player agrees
							to receive marketing and promotional communications from Buffalo Wild Wings, Inc. Players
							may opt out of the receipt of such communications at their discretion. Opting out will not
							affect the Player’s eligibility to participate in the Promotion or receive prizes.
						</p>

						<p>
							<strong>HOW TO PARTICIPATE.</strong>
							To participate in the Promotion, Players must download the BWW App by requesting the BWW App
							via{' '}
							<a href="https://buffalowildwings.com" target="_blank"
							   rel="noopener noreferrer">https://buffalowildwings.com</a> or as available on the Apple
							App Store or Google Play. The BWW App is available for download at no charge. Players must
							also either (i) have an existing Blazin’ Rewards account or (ii) create a free account with
							Blazin’ Rewards (located at
							<a href="https://buffalowildwings.com" target="_blank"
							   rel="noopener noreferrer">https://buffalowildwings.com</a> or via the App (together the
							“BWW Website”)) for the Promotion by completing the BWW registration requirements on that
							page
							("BWW Registration Requirements"). To complete the BWW Registration Requirements, Players
							will be required to provide a username of their choice, a password, email address, phone
							number, date of birth, and country and state of residence (as applicable), which Players
							acknowledge shall be considered Player’s contact information for purposes of the Promotion.
						</p>

						<p>
							A potential winner will be required to provide proof that he/she is the person set forth on
							the BWW Registration Requirements as evidenced by appropriate documentation, as determined
							in BWW’s sole discretion. Once Players have registered for their Blazin’ Rewards account,
							they can then enter the Promotion using their BWW login details via the BWW App..
						</p>
						<p>
							Participating is free. Limit: One (1) account registration/game play for the Promotion.
							Multiple account registrations will automatically result in disqualification.
						</p>
						<p>
							Proof of submission of an entry does not constitute proof of receipt of entry by BWW or its
							agents. BWW WILL NOT ACCEPT SCREEN SHOTS OR OTHER EVIDENCE OF WINNING IN LIEU OF ITS
							VALIDATION PROCESS. ANY ENTRY THAT OCCURS AFTER THE SYSTEM HAS FAILED FOR ANY REASON IS
							DEEMED DEFECTIVE AND IS VOID AND WILL NOT BE HONORED. BWW reserves the right to void all
							entries made through any third-party website or service, or through any robotic, automatic,
							mechanical, programmed or similar entry duplication method, and to disqualify any individual
							using such a website/service or entry method. Facsimiles or mechanical reproductions will
							not be accepted and Players may not use any other device or artifice to enter in excess of
							the number of entries allowed.
						</p>

						<p>
							<strong>RULES OF PLAY; CONTEST PRIZES. </strong>
							S. Game play includes one contest per day that will have between 3 and 8 questions based on
							event outcomes selected by Sponsor. Game play rules and details on how to play will be
							provided in the game menu on the Buffalo Wild Wings App.
						</p>

						<p>
							<strong>Cancelled, Postponed, and Rescheduled Games.</strong>
							In the event that a game is canceled, postponed, or rescheduled to a time outside of the
							original scoring period for that game, the game will be disabled from the Promotion and
							selections made with respect to that game will not accrue credit or points.

						</p>
						<SmallHeader>
							<strong>
								<u>CONTEST PRIZES: </u>
							</strong>
						</SmallHeader>
						<div>
							<strong>End of Promotion Month Contest Prizes (Monthly Prizing)</strong>

							<p>
								At the conclusion of the Promotion Month, the following contest prizes will be awarded,
								subject to verification of the potential winner’s eligibility and satisfaction of all
								conditions to claim or use the prize:
							</p>

							<ul>
								<li>
									<p>
										<p>Daily Prizes: </p>
										100 Blazin’ Rewards Points - Players that achieve the following contest status
										through game play each week will receive 100 Blazin’ Rewards Points for use
										towards in-store purchases at participating BWW restaurant locations. Blazin
										Rewards Points are governed by Blazin Rewards terms found here –
										<a href="https://www.blazinrewards.com/Common/Home/AboutTheProgram">
											https://www.blazinrewards.com/Common/Home/AboutTheProgram
										</a> and will be applied
										directly to the winner’s account, upon verification by Sponsor within 48 hours.
									</p>
								</li>
							</ul>

							<strong>End of Promotion Month Contest Prizes (Monthly Prizing)</strong>

							<p>
								At the conclusion of the Promotion Month, the following contest prizes will be awarded,
								subject to verification of the potential winner’s eligibility and satisfaction of all
								conditions to claim or use the prize:
							</p>

							<ul>
								<li>
									<p>
										Overall Winner (1 winner) - <strong>[Check-in by end of Promotion Period for
										eligibility]</strong> is the Player at the top of the overall leaderboard at the
										end of the Promotion as determined in accordance with the game play rules.
									</p>
									<p>
										Overall Winner prize is a Picks and Props Trophy, A championship ring, and a
										$100 Buffalo Wild Wings electronic gift card (ARV: $599).
									</p>
									<p>
										Top Additional Players on Monthly Leaderboard: Blazin’ Rewards Points.
									</p>
								</li>
								<li>
									<p>
										Players that achieve the following contest status through game play at the end
										of the Promotion Month (and are not eligible for another monthly contest prize)
										will receive the stated number of Blazin’ Rewards Points for use towards
										in-store purchases at participating BWW restaurant locations. The points will be
										automatically added to the winning Players’ accounts within 48 hours of the end
										of the Promotion Month. Blazin’ Rewards Points are governed by Blazin’ Rewards
										{/* tslint:disable-next-line:react-a11y-anchors */}
										terms found here - <a
										href="https://www.blazinrewards.com/Common/Home/AboutTheProgram">
										https://www.blazinrewards.com/Common/Home/AboutTheProgram
									</a> and
										will be applied directly to the winner’s account, upon verification by Sponsor.
									</p>
								</li>
							</ul>

							<br/>
							<table>
								<tr>
									<td>Top 2-25 Players</td>
									<td>1,000 Blazin’ Rewards Points</td>
								</tr>
								<tr>
									<td>Top 26-100 Players</td>
									<td>500 Blazin’ Rewards Points</td>
								</tr>
							</table>

							<br/>
						</div>

						<div>
							<p>
								<strong>TIEBREAKERS. </strong>
								In the event of a tie for a Promotion Month contest prize, the following procedures, in
								order, shall break the tie:
							</p>

							<ul>
								<li>
									Tie-breaker: Each weekly contest will have a tie-breaker question that will be used
									to break any ties. The final week tie breaker question will be used to break a tie
									for the overall winner and the top weekly winner
								</li>
							</ul>
						</div>

						<p>
							<strong>CONDITIONS ON CLAIMING PRIZE. </strong>
							Unless otherwise indicated herein, all expenses including, but not limited to, all taxes
							or other expense, are the responsibility of each winner. Each prize is non-transferable and
							no substitutions will be made except as provided herein at the Sponsor’s sole discretion.
							Potential winners will be notified by telephone, mail and/or email and may be required to
							complete an Affidavit of Eligibility, Liability and Publicity Release (unless prohibited by
							law) and any other documents required by BWW, which must be returned within the specified
							number of days after date appearing on prize notification. Return of prize or prize
							notification as undeliverable, failure to sign and return requested documentation within the
							specified time period, the inability of BWW to contact a potential winner within a
							reasonable time period or noncompliance with these Rules by any potential winner will result
							in disqualification and, at BWW’s sole discretion, the prize may be forfeited or awarded to
							a runner-up.
						</p>

						<div>
							<p>
								Where legal, the potential winners must consent to:
							</p>

							<ul>
								<li>
									Agree to be bound by and adhere to all rules and codes of conduct as required by the
									terms and conditions during your participation in the Promotion, and provide
									evidence of such compliance upon request
								</li>
								<li>
									Consent to the release of certain personal information to BWW for purposes related
									to participation and eligibility for your participation in the Promotion, and, upon
									BWW’s request, timely submit a publicity and liability waiver and release permitting
									disclosure of their name, general location (e.g., city/state), voice and likeness;
								</li>
								<li>Execute other documents as BWW may reasonably request; and
								</li>
								<li>
									Pay all taxes and like amounts in connection with the receipt of prizes and provide
									any and all information necessary as required by the Internal Revenue Service or any
									state taxing agency for information reporting required upon receipt of the prize
									(i.e., Form 1099, etc.)
								</li>
							</ul>
							<p>
								(hereinafter, collectively, the "<u>Requirements</u>").
							</p>
							<p>
								In the event a potential winner of a prize is not able to meet the Requirements for
								claiming the prizes, such winner shall not be entitled to the prize, or any other prize,
								compensation or monetary value whatsoever, and BWW will have no further obligation to
								the potential winner
							</p>
						</div>

						<p>
							<strong>PRIZE CONDITIONS. </strong>
							. Sponsor reserves the right to substitute a prize (or any element of a prize) for one of
							equal or greater retail value if the designated prize (or element of prize) should become
							unavailable for any reason. The value of each prize set forth above represent Sponsor’s good
							faith determination of the ARVs thereof, and the actual fair market value of each prize will
							be determined in Sponsor’s sole discretion, and will be final and binding and cannot be
							appealed. Actual value of prize may vary based on elements of prize selected and other
							factors. Each winner is responsible for reporting and payment of all taxes and fees
							associated with prize receipt and/or use.
						</p>

						<p>
							PRIZES ARE AWARDED “AS IS” AND WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED.
						</p>
						<p>
							Winners may not substitute, assign or transfer prize or redeem prize for cash, but BWW
							reserves the right, at its sole discretion, to substitute prize (or portion thereof) with
							one of comparable or greater value. Winners are responsible for all costs and expenses
							associated with prize acceptance and use that are not specified herein as being provided.
							All prize details are at BWW’s sole discretion.
						</p>
						<p>
							The stated ARV of the prize is based on available information provided to BWW. Any
							difference in ARV at the time of awarding will not be awarded, and the value of any prize
							awarded to a winner may be reported for tax purposes as required by law.
						</p>
						<p>
							<strong>TAXES. </strong>
							. Under prevailing federal, state, and local tax rules and regulations, a prize may
							constitute taxable income to a winner. Please consult with a tax professional to discuss the
							tax implications of a prize. BWW may require winners to complete and submit a Form W-9 as a
							condition of receiving a prize, and a winner may be required to furnish his/her social
							security number for the sole purpose of legal compliance, including preparation of any tax
							forms as required by law. Winners are solely responsible for any federal, state, or local
							taxes that may be due on a prize or the value of a prize, and winners may be issued an IRS
							Form 1099 and/or a state tax disclosure form reporting the value of the prize.
						</p>
						<p>
							<strong>WARRANTIES AND PUBLICITY CONSENT. </strong>
							T. By entering the Promotion, you: (a) represent and warrant that (i) you have read, and
							agree to be bound by, these Rules and any applicable policies or, as applicable, (ii) based
							on these Rules, you are eligible to participate in the Promotion, and (iii) all of the
							information provided as part of your entry is accurate, does not violate any third party’s
							legal rights (including, without limitation, rights of privacy and publicity), and otherwise
							does not violate applicable law; and (b) agrees and consents, without further authorization,
							compensation or remuneration of any kind, to the editing, modification, replication,
							publication and/or other use of your name, likeness, photograph,
							statements, general location (city/state), entries and the like in any medium, whether now
							known or hereafter developed, including without limitation, any and all advertising,
							promotions, and other publicity conducted by BWW. Notwithstanding the generality of the
							foregoing, each Player further assigns any and all rights he or she may have over his or her
							entry to BWW without further authorization, compensation or remuneration of any kind.
						</p>
						<p>
							<strong>DISCLAIMER OF WARRANTIES. </strong>
							BWW IS PROVIDING THE PROMOTION AND ALL PRIZES ON AN “AS IS” AND “AS AVAILABLE” BASIS WITHOUT
							WARRANTY OR GUARANTEE, EXPRESS OR IMPLIED. BWW DOES NOT REPRESENT OR WARRANT THAT THE
							PROMOTION OR THE TECHNOLOGY USED TO PROVIDE IT: (I) WILL BE UNINTERRUPTED OR SECURE; (II)
							WILL BE FREE OF DEFECTS, INACCURACIES OR ERRORS; OR (III) WILL MEET YOUR REQUIREMENTS OR
							ENABLE YOU TO PARTICIPATE IN IT. NEITHER BWW NOR ANY OF THE OTHER RELEASED PARTIES HAVE MADE
							ANY WARRANTY, REPRESENTATION OR GUARANTEE, EXPRESSED OR IMPLIED, IN FACT OR IN LAW, WITH
							RESPECT TO ANY PRIZE AWARDED, AND SPECIFICALLY DISCLAIM ALL SUCH WARRANTIES, REPRESENTATIONS
							OR GUARANTEES.
						</p>
						<p>
							<strong>LIABILITY RELEASE. </strong>
							E. By entering, each Player agrees to: (a) comply with and be bound by these Rules and the
							decisions of BWW in its sole discretion in administering these Rules; (b) FOREVER RELEASE,
							DISCHARGE, HOLD HARMLESS FROM, INDEMNIFY, AND COVENANT NOT TO SUE the Promotion Entities and
							any of their owners, employees, officers, directors, or shareholders ("Released Parties”)
							from and against any and all injuries, claims, damages, causes of action, demands, or
							liabilities of any kind (including, personal injury, property damage or death), regardless
							of the cause, whether known or unknown, which Player has or may have, including those
							arising from the partial or sole negligence of, or any act or omission of, Sponsor or any
							other Released Party and/or arising from or related to (i) my participation in the Promotion
							or related to the production, promotion, or execution of the Promotion; (ii) use or non-use
							of the recordings, advertising, publicity and promotional materials as permitted under these
							Rules (including claims based on rights of publicity or privacy or for injunctive or other
							relief); or (iii) redemption, use, or misuse of any prize or gift Player may receive as part
							of the Promotion; provided, however, this release shall not apply to claims of gross
							negligence or willful misconduct against a Released Party.
						</p>

						<p>
							By participating, Players also agree not to release any publicity or other materials on
							their own or through someone else regarding their participation in the Promotion without the
							prior consent of BWW, which it may withhold in its sole discretion.
						</p>

						<ul>
							<li>
								<p><strong>California Residents: </strong>
									By participating, Players also agree not to release any publicity or other materials
									on their own or through someone else regarding their participation in the Promotion
									without the prior consent of BWW, which it may withhold in its sole discretion.</p>
								<p>
									By participating, Players also agree not to release any publicity or other materials
									on their own or through someone else regarding their participation in the Promotion
									without the prior consent of BWW, which it may withhold in its sole discretion.“
								</p>
							</li>
							<li>
								Notwithstanding the provisions of Section 1542, being aware of Section 1542, I hereby
								expressly and voluntarily waive any rights I, my personal representatives, executors,
								heirs, next of kin and any other on my behalf, may have thereunder, as well as under any
								other statutes or common law principles of similar effect.
							</li>
						</ul>

						<p>
							<strong>DISPUTES; MANDATORY ARBITRATION: </strong>
							Notwithstanding the provisions of Section 1542, being aware of Section 1542, I hereby
							expressly and voluntarily waive any rights I, my personal representatives, executors, heirs,
							next of kin and any other on my behalf, may have thereunder, as well as under any other
							statutes or common law principles of similar effect.
						</p>
						<p>
							<strong>LIMITATION OF LIABILITY. </strong>
							. Notwithstanding the provisions of Section 1542, being aware of Section 1542, I hereby
							expressly and voluntarily waive any rights I, my personal representatives, executors, heirs,
							next of kin and any other on my behalf, may have thereunder, as well as under any other
							statutes or common law principles of similar effect.
						</p>
						<p>
							<strong>EFFECT OF RULES ON TERMS OF USE.</strong> The Terms of Use on the BWW website (<a
							href="https://www.buffalowildwings.com/en/terms-and-conditions/"
							target="_blank"
							rel="noopener noreferrer">https://www.buffalowildwings.com/en/terms-and-conditions/</a>)
							hall apply to the Promotion and to these Rules, and are hereby incorporated herein by
							reference. These Rules are intended to be a supplement to the Terms of Use, and should not
							be determined to be a substitute or replacement for, or otherwise render inapplicable, the
							Terms of Use. In no way other than through a provision of these Rules that explicitly
							conflicts with a provision in the Terms of Use shall these Rules be deemed to replace or
							nullify any provision contained in the Terms of Use
						</p>
						<p>
							<strong>PRIVACY.</strong>Personal information collected from Players is subject to the
							Privacy
							Policy on the
							BWW website (<a
							href="https://www.buffalowildwings.com/en/privacy-policy-terms/"
							target="_blank"
							rel="noopener noreferrer">https://www.buffalowildwings.com/en/privacy-policy-terms/</a>). {' '}
							BWW may engage certain third party companies to perform services in connection with the
							administration of this Promotion and information provided by Players may be collected and
							used by those third parties for purposes of administration of the Promotion and the
							fulfillment and verification of prize awards. These Rules are intended to be a supplement to
							the Privacy Policy, and should not be determined to be a substitute or replacement for, or
							otherwise render inapplicable, the Privacy Policy. In no way other than through a provision
							of these Rules that explicitly conflicts with a provision in the Privacy Policy shall these
							Rules be deemed to replace or nullify any provision contained in the Privacy Policy.

						</p>
						<p>
							<strong>GENERAL TERMS. </strong>
							. As used herein, a "Force Majeure" event shall mean the interruption of or material
							interference with BWW’s ability to grant to the winners the Prize by any cause or occurrence
							not within
							BWW’s reasonable control, including, but not limited to, fire, flood, epidemic, pandemic,
							earthquake, explosion, hurricane, terrorist threat or activity, public health emergency
							(e.g., SARS), act of God or public enemy, satellite or equipment failure, riot or civil
							disturbance, war (declared or undeclared), or any federal, state or local government law,
							order or regulation, or order of any court. In the event of a Force Majeure, BWW may
							reschedule the Promotion or may cancel the Promotion altogether.
						</p>
						<p>
							Persons who tamper with or abuse any aspect of the Promotion, the BWW App, or BWW website,
							who act in an unsportsmanlike or disruptive manner or who are in violation of these Rules,
							as solely determined by BWW, will be disqualified and associated entries will be void.
							Should any portion of the Promotion be, in BWW’s sole opinion, compromised by virus, worms,
							bugs, non-authorized human intervention or other causes which, in the sole opinion of the
							BWW, corrupt or impair the administration, security, fairness or proper play, or submission
							of entries, BWW reserves the right at its sole discretion to suspend, modify or terminate
							the Promotion and, if terminated, at its discretion, select the potential winner[s] from all
							eligible, non-suspect entries received prior to such action.
						</p>
						<p>
							BWW reserves the right to alter these Rules and event at any time in BWW’s sole discretion
							upon reasonable notice to you.
						</p>
						<p>
							BWW reserves the right to conduct a background check of any criminal records of any prize
							winner. To the extent necessary and permitted by law, prize winners authorize this
							background check. BWW reserves the right, at its sole discretion, to disqualify any prize
							winner from any prize element, based on the background check. Winners also accept sole
							responsibility for any miscellaneous costs relating to acceptance of prize.
						</p>
						<p>
							CAUTION: ANY ATTEMPT BY A PERSON TO DELIBERATELY DAMAGE THE BWW WEBSITE OR TO UNDERMINE THE
							LEGITIMATE OPERATION OF THIS PROMOTION IS A VIOLATION OF CRIMINAL AND CIVIL LAWS. SHOULD
							SUCH AN ATTEMPT BE MADE, BWW RESERVES THE RIGHT TO SEEK DAMAGES (INCLUDING ATTORNEYS’ FEES)
							FROM ANY SUCH PERSON TO THE FULLEST EXTENT PERMITTED BY LAW AND TO SEEK CRIMINAL
							PROSECUTION.
						</p>
						<p>
							<strong>PROMOTION RESULTS. </strong>
							Promotion results and prize calculations are based on the final statistics and scoring
							results at the completion of the last professional sports game of each scoring period. Once
							Promotion results are reviewed and graded, prizes are awarded. The scoring results of a
							scoring period will not be changed regardless of any official statistics or scoring
							adjustments made at later times or dates, except in BWW's sole discretion.
						</p>
						<p>
							For a list of winners, send a self-addressed, stamped, envelope by six months following the
							specific Promotion Day and/or Promotion Month, with information specifying the date(s) of
							the contest for which you are seeking information to: Buffalo Wild Wings, Inc., 3 Glendale Parkway NE Atlanta, GA 30328.
						</p>

						<p>
							If you have questions or comments, please contact us at <a
							href="https://www.buffalowildwings.com/en/contact-us/"
							target="_blank" rel="noopener noreferrer">
							https://www.buffalowildwings.com/en/contact-us/.</a>
						</p>
						<LargeHeader>OFFICIAL RULES - PICKS AND PROPS FOOTBALL PLAYOFF CONTEST</LargeHeader>
						<p>
							PLEASE CAREFULLY READ THESE RULES BEFORE PARTICIPATING IN THE BUFFALO WILD WINGS PICKS AND
							PROPS FOOTBALL PLAYOFF PROMOTION (“PROMOTION”) AS THESE RULES AFFECT YOUR LEGAL RIGHTS AND
							OBLIGATIONS.<br/><br/>

							NO PURCHASE NECESSARY TO ENTER THE PROMOTION OR WIN. A PURCHASE WILL NOT INCREASE YOUR
							CHANCES OF WINNING. Promotion is strictly for entertainment purposes and is not intended to
							be used in any way for gambling or sports wagering purposes (or to conduct, advertise or
							promote any form of gambling). Promotion is subject to all applicable federal, state and
							local laws. Void where prohibited. MESSAGE & DATA RATES MAY APPLY.<br/><br/>

							IMPORTANT NOTICE: THIS PROMOTION IS SUBJECT TO BINDING ARBITRATION AND A WAIVER OF CLASS
							ACTION RIGHTS AS DETAILED BELOW.<br/><br/>

							PROMOTION DESCRIPTION. The Promotion IS FREE TO PLAY. Promotion offered is a game of skill
							where the outcome is determined by the Player’s skill rather than chance or luck. The
							Promotion takes place via the official Buffalo Wild Wings mobile application (the “BWW App”)
							or buffalowildwings.com (together the “BWW Website”)) and is administered and scored
							according to the game rules as provided on the BWW Website. Promotion is sponsored by
							Buffalo Wild Wings, Inc., Three Glenlake Parkway NE Atlanta, GA 30328 (“BWW” or “Sponsor”).
							Entrants to the Promotion (“Player” or “Players”) will have the opportunity to play games
							for the opportunity to win a cash prize as provided in these Rules. <b>Players may
							participate in the Promotion on the BWW App or buffalowildwings.com, but must check in on
							the BWW App at a participating BWW location or place an ecommerce order from a participating
							BWW location during the Promotion Period and during the Promotion Days for game points to
							count for potential prizes.</b><br/><br/>

							PROMOTION PERIOD. Promotion begins at 11:00 AM EST January 6, 2021 and ends at 11:59 PM EST
							on February 9, 2021 (“Promotion Period”). Each “Promotion Day” will run starting from 12:01
							AM EST on a given day until 11:59 PM EST on that day. Promotion Days, which are subject to
							change, include professional football playoff games, which are currently scheduled for:
							January 9, 10, 16, 17, and 24 and February 7, 2021. Potential winners will be determined and
							prizes awarded throughout the Promotion Period as further set forth these Rules.<br/><br/>

							ELIGIBILITY TO PARTICIPATE. Players must be 21 years of age or older, a resident of one of
							the 50 United States or DC, and go online at buffalowildwings.com or be eligible to download
							and use the BWW App to participate in the Promotion. The following individuals are not
							eligible to participate in the Promotion: (a) owners, directors, employees, and
							representatives of Buffalo Wild Wings, Inc., Inspire Brands, Inc., and their parents,
							affiliates, franchisees, licensees, agents and vendors, and their respective advertising,
							promotion and fulfillment agencies, promotional partners, and entities involved with the
							development, implementation and handling of the Promotion (collectively, the “Promotion
							Entities”) and (b) the immediate family (spouse, parents and step-parents, siblings and
							step-siblings, and children and step-children, regardless of where they reside) and
							household members (people who share the same residence at least three (3) months out of the
							year, whether or not related) of each such individual. Potential winners are subject to
							verification by BWW. A Player is not a winner of any prize unless and until eligibility is
							verified and Player is notified that verification is complete. Each Player fully and
							unconditionally accepts these Official Rules and the decisions of Sponsor, which are final
							and binding in all matters relating to the Promotion and waives any right to claim ambiguity
							in these Official Rules.<br/><br/>

							MARKETING COMMUNICATIONS. By entering the Promotion, each Player agrees to receive marketing
							and promotional communications from Buffalo Wild Wings, Inc. Players may opt out of the
							receipt of such communications at their discretion. Opting out will not affect the Player’s
							eligibility to participate in the Promotion or receive prizes.<br/><br/>

							HOW TO PARTICIPATE. To participate in the Promotion, Players may go online at
							buffalowildwings.com or download the BWW App by requesting the BWW App via
							buffalowildwings.com or as available on the Apple App Store or Google Play. The BWW App is
							available for download at no charge. <b>To be eligible to win prizing</b>, Players must: (1)
							either (i) have an existing Blazin’ Rewards account or (ii) create a free account with
							Blazin’ Rewards (located at www.buffalowildwings.com or via the App) for the Promotion by
							completing the BWW registration requirements on that page ("BWW Registration Requirements"),
							and (2) during the Promotion Period and relevant Promotion Days, either (i) check in on the
							BWW App at a participating BWW location or (ii) place an ecommerce order from a
							participating BWW location. To complete the BWW Registration Requirements, Players will be
							required to provide a username of their choice, a password, email address, phone number,
							date of birth, and country and state of residence (as applicable), which Players acknowledge
							shall be considered Player’s contact information for purposes of the Promotion.<br/><br/>

							A potential winner will be required to provide proof that he/she is the person set forth on
							the BWW Registration Requirements as evidenced by appropriate documentation, as determined
							in BWW’s sole discretion. Once Players have registered for their Blazin’ Rewards account,
							they can then enter the Promotion using their BWW login details via the BWW App.<br/><br/>

							Participating is free. Limit: One (1) account registration/game play for the Promotion.
							Multiple account registrations will automatically result in disqualification.<br/><br/>

							Proof of submission of an entry does not constitute proof of receipt of entry by BWW or its
							agents. BWW WILL NOT ACCEPT SCREEN SHOTS OR OTHER EVIDENCE OF WINNING IN LIEU OF ITS
							VALIDATION PROCESS. ANY ENTRY THAT OCCURS AFTER THE SYSTEM HAS FAILED FOR ANY REASON IS
							DEEMED DEFECTIVE AND IS VOID AND WILL NOT BE HONORED. BWW reserves the right to void all
							entries made through any third-party website or service, or through any robotic, automatic,
							mechanical, programmed or similar entry duplication method, and to disqualify any individual
							using such a website/service or entry method. Facsimiles or mechanical reproductions will
							not be accepted and Players may not use any other device or artifice to enter in excess of
							the number of entries allowed.<br/><br/>

							RULES OF PLAY; CONTEST PRIZES. Game play includes a contest that will have between 6 and 12
							questions based on event outcomes selected by Sponsor. Game play rules and details on how to
							play will be provided in the game menu on the BWW Website.<br/><br/>

							Cancelled, Postponed, and Rescheduled Games. In the event that a game is canceled,
							postponed, or rescheduled to a time outside of the original scoring period for that game,
							the game will be disabled from the Promotion and selections made with respect to that game
							will not accrue credit or points. If a game is rescheduled to a different date or time
							during the Promotion Period, it will still count as a Promotion Day.<br/><br/>

							CONTEST PRIZES:<br/><br/>

							The following contest prizes will be awarded, subject to verification of the potential
							winner’s eligibility and the potential winner’s satisfaction of all conditions to claim or
							use the prize.<br/><br/>

							The Player that makes correct selections for all predictions/questions selected by Sponsor
							for the game play in a Promotion Day will win $10,000. Each $10,000 prize will be awarded
							upon the completion of each Promotion Day, subject to verification and eligibility
							requirements. Six total prizes may be awarded. The Actual Retail Value (“ARV”) of all prizes
							for the Promotion Period is $60,000. All prizes may not be awarded, at Sponsor’s discretion,
							if no Player qualifies for the prize award for a given Promotion Day or if a playoff game
							for a Promotion Day is cancelled and not rescheduled during the Promotion Period.<br/><br/>

							TIEBREAKERS. In the event of a tie, the following procedures shall break the tie:<br/><br/>

							Tie-breaker: Correct response to specific question based on an event outcome.<br/><br/>

							If multiple Players overcome the tie-breaker, the Promotion Day prize of $10,000 shall be
							divided evenly among all eligible Players who overcame the tie-breaker, subject to
							verification.<br/><br/>

							CONDITIONS ON CLAIMING PRIZE. Unless otherwise indicated herein, all expenses including, but
							not limited to, all taxes or other expenses, are the responsibility of each winner. Each
							prize is non-transferable and no substitutions will be made except as provided herein at the
							Sponsor’s sole discretion. Potential winners will be notified by telephone, mail and/or
							email and may be required to complete an Affidavit of Eligibility, Liability and Publicity
							Release (unless prohibited by law) and any other documents required by BWW, which must be
							returned within the specified number of days after date appearing on prize notification.
							Return of prize or prize notification as undeliverable, failure to sign and return requested
							documentation within the specified time period, the inability of BWW to contact a potential
							winner within a reasonable time period or noncompliance with these Rules by any potential
							winner will result in disqualification and, at BWW’s sole discretion, the prize may be
							forfeited or awarded to a runner-up.<br/><br/>
							Where legal, the potential winners must consent to:<br/><br/>
							<ul>
								<li>
									Agree to be bound by and adhere to all rules and codes of conduct as required by the
									terms and conditions during your participation in the Promotion, and provide
									evidence of such compliance upon request;
								</li>
								<li>
									Consent to the release of certain personal information to BWW for purposes related
									to participation and eligibility for your participation in the Promotion, and, upon
									BWW’s request, timely submit a publicity and liability waiver and release permitting
									disclosure of their name, general location (e.g., city/state), voice and likeness;
								</li>
								<li>
									Execute other documents as BWW may reasonably request; and
								</li>
								<li>
									Pay all taxes and like amounts in connection with the receipt of prizes and provide
									any and all information necessary as required by the Internal Revenue Service or any
									state taxing agency for information reporting required upon receipt of the prize
									(i.e., Form 1099, etc.).
									(hereinafter, collectively, the "Requirements").
								</li>
							</ul>

							In the event a potential winner of a prize is not able to meet the Requirements for claiming
							the prizes, such winner shall not be entitled to the prize, or any other prize, compensation
							or monetary value whatsoever, and BWW will have no further obligation to the potential
							winner.<br/><br/>

							PRIZE CONDITIONS. Sponsor reserves the right to substitute a prize (or any element of a
							prize) for one of equal or greater retail value if the designated prize (or element of
							prize) should become unavailable for any reason. The value of each prize set forth above
							represent Sponsor’s good faith determination of the ARVs thereof, and the actual fair market
							value of each prize will be determined in Sponsor’s sole discretion, and will be final and
							binding and cannot be appealed. Actual value of prize may vary based on elements of prize
							selected and other factors. Each winner is responsible for reporting and payment of all
							taxes and fees associated with prize receipt and/or use.<br/><br/>

							PRIZES ARE AWARDED “AS IS” AND WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED.<br/><br/>

							In the event that any part of a Prize is cancelled, postponed or preempted for any reason or
							cannot be awarded due to applicable legal or regulatory requirements or the terms of prize
							suppliers, no rain checks, exchanges, substitution or cash replacement value of the Prize
							will be provided except at Sponsor’s discretion. Winners are responsible for all costs and
							expenses associated with prize acceptance and use that are not specified herein as being
							provided. All prize details are at BWW’s sole discretion.<br/><br/>

							The stated ARV of the prize is based on available information provided to BWW. Any
							difference in ARV at the time of awarding will not be awarded, and the value of any prize
							awarded to a winner may be reported for tax purposes as required by law.<br/><br/>

							TAXES. Under prevailing federal, state, and local tax rules and regulations, a prize may
							constitute taxable income to a winner. Please consult with a tax professional to discuss the
							tax implications of a prize. BWW may require winners to complete and submit a Form W-9 as a
							condition of receiving a prize, and a winner may be required to furnish his/her social
							security number for the sole purpose of legal compliance, including preparation of any tax
							forms as required by law. Winners are solely responsible for any federal, state, or local
							taxes that may be due on a prize or the value of a prize, and winners may be issued an IRS
							Form 1099 and/or a state tax disclosure form reporting the value of the prize.<br/><br/>

							WARRANTIES AND PUBLICITY CONSENT. By entering the Promotion, you: (a) represent and warrant
							that (i) you have read, and agree to be bound by, these Rules and any applicable policies
							or, as applicable, (ii) based on these Rules, you are eligible to participate in the
							Promotion, and (iii) all of the information provided as part of your entry is accurate, does
							not violate any third party’s legal rights (including, without limitation, rights of privacy
							and publicity), and otherwise does not violate applicable law; and (b) agrees and consents,
							without further authorization, compensation or remuneration of any kind, to the editing,
							modification, replication, publication and/or other use of your name, likeness, photograph,
							statements, general location (city/state), entries and the like in any medium, whether now
							known or hereafter developed, including without limitation, any and all advertising,
							promotions, and other publicity conducted by BWW. Notwithstanding the generality of the
							foregoing, each Player further assigns any and all rights he or she may have over his or her
							entry to BWW without further authorization, compensation or remuneration of any
							kind.<br/><br/>

							DISCLAIMER OF WARRANTIES. BWW IS PROVIDING THE PROMOTION AND ALL PRIZES ON AN “AS IS” AND
							“AS AVAILABLE” BASIS WITHOUT WARRANTY OR GUARANTEE, EXPRESS OR IMPLIED. BWW DOES NOT
							REPRESENT OR WARRANT THAT THE PROMOTION OR THE TECHNOLOGY USED TO PROVIDE IT: (I) WILL BE
							UNINTERRUPTED OR SECURE; (II) WILL BE FREE OF DEFECTS, INACCURACIES OR ERRORS; OR (III) WILL
							MEET YOUR REQUIREMENTS OR ENABLE YOU TO PARTICIPATE IN IT. NEITHER BWW NOR ANY OF THE OTHER
							RELEASED PARTIES HAVE MADE ANY WARRANTY, REPRESENTATION OR GUARANTEE, EXPRESSED OR IMPLIED,
							IN FACT OR IN LAW, WITH RESPECT TO ANY PRIZE AWARDED, AND SPECIFICALLY DISCLAIM ALL SUCH
							WARRANTIES, REPRESENTATIONS OR GUARANTEES.<br/><br/>

							LIABILITY RELEASE. By entering, each Player agrees to: (a) comply with and be bound by these
							Rules and the decisions of BWW in its sole discretion in administering these Rules; (b)
							FOREVER RELEASE, DISCHARGE, HOLD HARMLESS FROM, INDEMNIFY, AND COVENANT NOT TO SUE the
							Promotion Entities and any of their owners, employees, officers, directors, or shareholders
							("Released Parties”) from and against any and all injuries, claims, damages, causes of
							action, demands, or liabilities of any kind (including, personal injury, property damage or
							death), regardless of the cause, whether known or unknown, which Player has or may have,
							including those arising from the partial or sole negligence of, or any act or omission of,
							Sponsor or any other Released Party and/or arising from or related to (i) my participation
							in the Promotion or related to the production, promotion, or execution of the Promotion;
							(ii) use or non-use of the recordings, advertising, publicity and promotional materials as
							permitted under these Rules (including claims based on rights of publicity or privacy or for
							injunctive or other relief); or (iii) redemption, use, or misuse of any prize or gift Player
							may receive as part of the Promotion; provided, however, this release shall not apply to
							claims of gross negligence or willful misconduct against a Released Party.<br/><br/>

							By participating, Players also agree not to release any publicity or other materials on
							their own or through someone else regarding their participation in the Promotion without the
							prior consent of BWW, which it may withhold in its sole discretion.<br/><br/>

							California Residents: I acknowledge that I have been advised or had the opportunity to be
							advised by legal counsel, and I understand, my waiver shall include the provisions of
							California Civil Code Section 1542 (“Section 1542”), which provides as follows:<br/><br/>

							“A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS THAT THE CREDITOR OR RELEASING PARTY DOES NOT
							KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE RELEASE AND THAT,
							IF KNOWN BY HIM OR HER, WOULD HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR
							OR RELEASED PARTY.<br/><br/>

							Notwithstanding the provisions of Section 1542, being aware of Section 1542, I hereby
							expressly and voluntarily waive any rights I, my personal representatives, executors, heirs,
							next of kin and any other on my behalf, may have thereunder, as well as under any other
							statutes or common law principles of similar effect.<br/><br/>

							DISPUTES; MANDATORY ARBITRATION: Except where prohibited by law, as a condition of
							participating in this Promotion, Player agrees that (1) any and all disputes and causes of
							action arising out of or connected with this Promotion, or prize awarded, shall be resolved
							individually, without resort to any form of class action, and exclusively by final and
							binding arbitration under the rules of the American Arbitration Association and held at the
							AAA regional office nearest the Player; (2) the Federal Arbitration Act shall govern the
							interpretation, enforcement and all proceedings at such arbitration; and (3) judgment upon
							such arbitration award may be entered in any court having jurisdiction. Under no
							circumstances will Player be permitted to obtain awards for, and Player hereby waives all
							rights to claim, punitive, incidental or consequential damages, or any other damages,
							including attorneys' fees, other than Player's actual out-of-pocket expenses (i.e., costs
							associated with participating in this Promotion), and Player further waives all rights to
							have damages multiplied or increased.<br/><br/>


							LIMITATION OF LIABILITY. The Released Parties are not responsible for: (a) any incorrect or
							inaccurate information, whether caused by Players, printing errors or by any of the
							equipment or programming associated with or utilized in the Promotion; (b) lost, late,
							incomplete, damaged, inaccurate, unreadable, stolen, delayed, misdirected, undelivered, or
							garbled entries or technical failures of any kind, including, but not limited to
							malfunctions, interruptions or disconnections in phone lines or network hardware or
							software; (c) unauthorized human intervention in any part of the entry process or the
							Promotion; (d) technical or human error which may occur in the administration of the
							Promotion or the processing of entries or calculation of game play entries; or (e) any
							injury or damage to persons or property (including any person’s computer, phone or device)
							which may be caused, directly or indirectly, in whole or in part, from Player’s
							participation in the Promotion or receipt or use or misuse of any prize. If for any reason a
							Player’s entry is confirmed to have been erroneously deleted, lost or otherwise destroyed or
							corrupted, Player’s sole remedy is another entry in the Promotion. In the event that
							production, technical, seeding, programming or any other reasons cause more than the stated
							number of prizes as set forth in these Promotion Rules to be available and/or claimed, BWW
							reserves the right to award only the stated number of prizes from among all legitimate,
							unawarded, eligible prize claims.<br/><br/>

							EFFECT OF RULES ON TERMS OF USE. The Terms of Use on the BWW website
							(https://www.buffalowildwings.com/en/terms-and-conditions/) shall apply to the Promotion and
							to these Rules and are hereby incorporated herein by reference. These Rules are intended to
							be a supplement to the Terms of Use and should not be determined to be a substitute or
							replacement for, or otherwise render inapplicable, the Terms of Use. In no way other than
							through a provision of these Rules that explicitly conflicts with a provision in the Terms
							of Use shall these Rules be deemed to replace or nullify any provision contained in the
							Terms of Use.<br/><br/>

							PRIVACY. Personal information collected from Players is subject to the Privacy Policy on the
							BWW website (https://www.buffalowildwings.com/en/privacy-policy-terms/). BWW may engage
							certain third party companies to perform services in connection with the administration of
							this Promotion and information provided by Players may be collected and used by those third
							parties for purposes of administration of the Promotion and the fulfillment and verification
							of prize awards. These Rules are intended to be a supplement to the Privacy Policy, and
							should not be determined to be a substitute or replacement for, or otherwise render
							inapplicable, the Privacy Policy. In no way other than through a provision of these Rules
							that explicitly conflicts with a provision in the Privacy Policy shall these Rules be deemed
							to replace or nullify any provision contained in the Privacy Policy.<br/><br/>

							GENERAL TERMS. As used herein, a "Force Majeure" event shall mean the interruption of or
							material interference with BWW’s ability to grant to the winners the Prize by any cause or
							occurrence not within BWW’s reasonable control, including, but not limited to, fire, flood,
							epidemic, pandemic, earthquake, explosion, hurricane, terrorist threat or activity, public
							health emergency (e.g., SARS), act of God or public enemy, satellite or equipment failure,
							riot or civil disturbance, war (declared or undeclared), or any federal, state or local
							government law, order or regulation, or order of any court. In the event of a Force Majeure,
							BWW may reschedule the Promotion or may cancel the Promotion altogether.<br/><br/>

							Persons who tamper with or abuse any aspect of the Promotion, the BWW App, or BWW Website,
							who act in an unsportsmanlike or disruptive manner or who are in violation of these Rules,
							as solely determined by BWW, will be disqualified and associated entries will be void.
							Should any portion of the Promotion be, in BWW’s sole opinion, compromised by virus, worms,
							bugs, non-authorized human intervention or other causes which, in the sole opinion of the
							BWW, corrupt or impair the administration, security, fairness or proper play, or submission
							of entries, BWW reserves the right at its sole discretion to suspend, modify or terminate
							the Promotion and, if terminated, at its discretion, select the potential winner[s] from all
							eligible, non-suspect entries received prior to such action.<br/><br/>

							BWW reserves the right to alter these Rules and event at any time in BWW’s sole discretion
							upon reasonable notice to you.<br/><br/>

							BWW reserves the right to conduct a background check of any criminal records of any prize
							winner. To the extent necessary and permitted by law, prize winners authorize this
							background check. BWW reserves the right, at its sole discretion, to disqualify any prize
							winner from any prize element, based on the background check. Winners also accept sole
							responsibility for any miscellaneous costs relating to acceptance of prize.<br/><br/>

							CAUTION: ANY ATTEMPT BY A PERSON TO DELIBERATELY DAMAGE THE BWW WEBSITE OR TO UNDERMINE THE
							LEGITIMATE OPERATION OF THIS PROMOTION IS A VIOLATION OF CRIMINAL AND CIVIL LAWS. SHOULD
							SUCH AN ATTEMPT BE MADE, BWW RESERVES THE RIGHT TO SEEK DAMAGES (INCLUDING ATTORNEYS’ FEES)
							FROM ANY SUCH PERSON TO THE FULLEST EXTENT PERMITTED BY LAW AND TO SEEK CRIMINAL
							PROSECUTION.<br/><br/>

							PROMOTION RESULTS. Promotion results and prize calculations are based on the final
							statistics and scoring results at the completion of the last professional sports game of
							each scoring period. Once Promotion results are reviewed and graded, prizes are awarded. The
							scoring results of a scoring period will not be changed regardless of any official
							statistics or scoring adjustments made at later times or dates, except in BWW's sole
							discretion.<br/><br/>

							For a list of winners, send a self-addressed, stamped, envelope by August 9, 2021, to:
							Buffalo Wild Wings, Inc., 3 Glendale Parkway NE Atlanta, GA 30328.<br/><br/>

							Contact<br/><br/>
							If you have questions or comments, please contact us at
							https://www.buffalowildwings.com/en/contact-us/.<br/><br/>
						</p>
					</ContentTextStyled>
				</div>
			</HOCisTrue>


			<Accordion onClick={toggleTrivia}>
				<span>Trivia</span>
				<IconChevron color={'#fff'} width={20} height={20} to={triviaChevron}/>
			</Accordion>
			<HOCisTrue when={triviaVisibility}>
				<div>
					<ContentTextStyled>
						{terms ? map(terms, (term_item, key) => (
							<div key={key}>
								<LargeHeader>
									{term_item.title}
								</LargeHeader>
								<HelpContent dangerouslySetInnerHTML={{__html: term_item.text}}/>
							</div>
						)) : null}
					</ContentTextStyled>
				</div>
			</HOCisTrue>
		</WrapperStyled>
	);
};
